import Util from './lib/Util';

export default {
	currency(value) {
		if (typeof value !== 'number') value = Number(value);
		if (!value) {
			return value;
		}
		return value.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,');
	},

	phone(v, separator = '-') {
		if (!v) return v;
		const tel = String(v);
		return tel.length === 10
			? tel
					.match(/^(\d{3})(\d{3})(\d{4})$/)
					.slice(1, 4)
					.join(separator)
			: tel.length === 11
				? tel
						.match(/^(\d{3})(\d{4})(\d{4})$/)
						.slice(1, 4)
						.join(separator)
				: tel;
	},

	dateFormat(v, pattern = 'YYYY-MM-DD HH:mm') {
		return Util.dateFormat(v, pattern);
	},

	stateClass(state) {
		if (state === '차단') {
			return 'red--text font-red';
		} else if (state === '검수' || state === '대기') {
			return 'orange--text color-orange';
		} else if (state === '정상') {
			return 'green--text color-green';
		} else {
			return 'grey--text disabled-text';
		}
	},

	number(num = 0) {
		return num.toLocaleString();
	},
};
